import React, { useState, useEffect } from "react";
import "../componnetsCss/SignUp.css"
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { app } from "../Firebase";
import "../App.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { collection, addDoc, getFirestore } from "firebase/firestore";
import { getDatabase, ref, set, update } from "firebase/database";
import Spinner from "react-bootstrap/Spinner";
import ContactUs from "./ContactUs";
import { Container } from "react-bootstrap";

const SignUp = (props) => {
  const [checkPass, setCheckPass] = useState(false);
  ////////// For Balance
  const [bal, setBal] = useState(109);
  console.log(props);
  //Sign Up User Statessss.............................
  const [email, SetEmail] = useState();
  const [password, SetPassword] = useState();
  const [userName, setUserName] = useState();

  //Sign in Error massage Statess......................
  const [chk, setChk] = useState(true);
  const [empty, setEmpty] = useState(true);
  //For Loading
  const [loading, setLoading] = useState(false);
  ////For Refernl Info
  const [refsCode, setrefCode] = useState();
  let currentDate = new Date().getDate();
  const activities = [

  "Ali Khan earned RS 250 from Watching Video",
  "Zeeshan: Withdrawal RS 1,200 successful via EasyPaisa",
  "Sara Ahmed upgraded to Package 1",
  "Usman Ahmed earned RS 180 from Watching Video",
  "Deposit RS 500 successful via EasyPaisa - Account Updated",
  "Hamza just upgraded to Package 2",
  "Ayesha: Withdrawal RS 1,500 successful via JazzCash",
  "Bilal Siddiqui earned RS 350 from Watching Video",
  "Sana Malik upgraded to Package 3",
  "Omer Farooq earned RS 120 from Watching Video",
  "Deposit RS 1,000 successful via JazzCash - Account Updated",
  "Maria Khan: Withdrawal RS 1,800 successful via EasyPaisa",
  "Fahad Mustafa earned RS 500 from Watching Video",
  "Raza Ali upgraded to Package 1",
  "Nida Sheikh earned RS 210 from Watching Video",
  "Kashif Jameel: Withdrawal RS 950 successful via EasyPaisa",
  "Deposit RS 1,500 successful via Bank Account - Confirmed",
  "Hina Pervez earned RS 400 from Watching Video",
  "Tanveer Ahmed upgraded to Package 2",
  "Zainab Bibi earned RS 150 from Watching Video",
  "Waqas Khan: Withdrawal RS 1,350 successful via JazzCash",
  "Asma Gull earned RS 280 from Watching Video",
  "Adnan Malik upgraded to Package 1",
  "Deposit RS 2,000 successful via EasyPaisa - Package Active",
  "Shoaib Akhtar earned RS 600 from Watching Video",
  "Mehak Jan: Withdrawal RS 1,100 successful via EasyPaisa",
  "Farhan Saeed upgraded to Package 3",
  "Iqra Aziz earned RS 220 from Watching Video",
  "Tayyaba Khan upgraded to Package 2",
  "Haris Rauf earned RS 450 from Watching Video",
  "Deposit RS 800 successful via JazzCash - Verified",
  "Nimra Ahmed: Withdrawal RS 1,400 successful via JazzCash",
  "Junaid Khan earned RS 190 from Watching Video",
  "Babar Azam upgraded to Package 1",
  "Saba Qamar earned RS 310 from Watching Video",
  "Muneeb Butt: Withdrawal RS 1,950 successful via EasyPaisa",
  "Arsalan Ash earned RS 240 from Watching Video",
  "Kubra Khan upgraded to Package 3",
  "Danish Taimoor earned RS 170 from Watching Video",
  "Deposit RS 300 successful via EasyPaisa - Instant Credit",
  "Fiza Ali: Withdrawal RS 1,600 successful via JazzCash",
  "Imran Abbas upgraded to Package 1",
  "Maya Ali earned RS 420 from Watching Video",
  "Sajal Aly upgraded to Package 2",
  "Ahad Raza Mir earned RS 130 from Watching Video",
  "Yumna Zaidi: Withdrawal RS 1,750 successful via EasyPaisa",
  "Bilal Abbas upgraded to Package 3",
  "Sanam Saeed earned RS 380 from Watching Video",
  "Fawad Khan: Withdrawal RS 1,900 successful via JazzCash",
  "Deposit RS 1,200 successful via Bank Account - Done",
  "Mahira Khan upgraded to Package 1",
  "Ushna Shah earned RS 260 from Watching Video",
  "Gohar Rasheed: Withdrawal RS 1,100 successful via EasyPaisa",
  "Sana Javed upgraded to Package 2",
  "Mikaal Zulfiqar earned RS 550 from Watching Video",
  "Zohaib Hassan earned RS 215 from Watching Video",
  "Irfan Pathan just upgraded to Package 3",
  "Bushra Bibi: Withdrawal RS 1,350 successful via JazzCash",
  "Deposit RS 500 successful via EasyPaisa - Package 1 Active",
  "Kamran Akmal earned RS 480 from Watching Video",
  "Noman Ali just upgraded to Package 1",
  "Seema Khan: Withdrawal RS 900 successful via EasyPaisa",
  "Saad Rafique earned RS 330 from Watching Video",
  "Hassan Ali just upgraded to Package 2",
  "Sumaira Ahmed: Withdrawal RS 1,450 successful via JazzCash",
  "Javed Miandad earned RS 160 from Watching Video",
  "Shahid Afridi just upgraded to Package 3",
  "Madiha Shah: Withdrawal RS 1,850 successful via JazzCash",
  "Deposit RS 1,000 successful via JazzCash - Confirmed",
  "Umar Akmal earned RS 290 from Watching Video",
  "Abid Ali just upgraded to Package 1",
  "Rameez Raja: Withdrawal RS 1,150 successful via EasyPaisa",
  "Bismah Maroof earned RS 410 from Watching Video",
  "Misbah-ul-Haq just upgraded to Package 2",
  "Shaheen Afridi: Withdrawal RS 1,650 successful via EasyPaisa",
  "Saeed Ajmal earned RS 205 from Watching Video",
  "Imad Wasim just upgraded to Package 1",
  "Muneeba Ali: Withdrawal RS 850 successful via JazzCash",
  "Sarfaraz Ahmed earned RS 520 from Watching Video",
  "Azhar Ali just upgraded to Package 3",
  "Deposit RS 2,000 successful via Bank Account - Verified",
  "Sohaib Maqsood: Withdrawal RS 1,200 successful via EasyPaisa",
  "Wahab Riaz earned RS 195 from Watching Video",
  "Asif Ali just upgraded to Package 2",
  "Faheem Ashraf: Withdrawal RS 1,450 successful via JazzCash",
  "Shadab Khan earned RS 375 from Watching Video",
  "Mohammad Rizwan just upgraded to Package 1",
  "Haris Sohail: Withdrawal RS 1,550 successful via EasyPaisa",
  "Fakhar Zaman earned RS 245 from Watching Video",
  "Iftikhar Ahmed just upgraded to Package 2",
  "Khurram Shahzad: Withdrawal RS 1,250 successful via EasyPaisa",
  "Abrar Ahmed earned RS 305 from Watching Video",
  "Mir Hamza just upgraded to Package 3",
  "Saim Ayub: Withdrawal RS 950 successful via JazzCash",
  "Mohammad Haris earned RS 440 from Watching Video",
  "Tayyab Tahir just upgraded to Package 1",
  "Usama Mir: Withdrawal RS 1,300 successful via EasyPaisa",
  "Zaman Khan earned RS 185 from Watching Video",
  "Ahsan Ali just upgraded to Package 2",
  "Anwar Ali: Withdrawal RS 1,900 successful via EasyPaisa",
  "Sohail Tanvir earned RS 275 from Watching Video",
  "Yasir Shah just upgraded to Package 1",
  "Zulqarnain Haider: Withdrawal RS 700 successful via JazzCash",
  "Rahat Ali earned RS 390 from Watching Video",
  "Mohammad Amir just upgraded to Package 3",
  "Junaid Khan: Withdrawal RS 1,800 successful via EasyPaisa",
  "Sohail Khan earned RS 140 from Watching Video",
  "Deposit RS 600 successful via EasyPaisa - Approved",
  "Maryam Nawaz: Withdrawal RS 1,800 successful via JazzCash",
  "Shehbaz Sharif upgraded to Package 2",
  "Imran Khan earned RS 460 from Watching Video",
  "Arshad Nadeem: Withdrawal RS 1,100 successful via EasyPaisa",
  "Asim Munir upgraded to Package 3",
  "Qasim Ali Shah earned RS 215 from Watching Video",
  "Sahir Lodhi: Withdrawal RS 1,400 successful via JazzCash",
  "Waseem Badami upgraded to Package 1",
  "Iqrar ul Hassan earned RS 380 from Watching Video",
  "Tariq Jameel: Withdrawal RS 1,500 successful via EasyPaisa",
  "Junaid Jamshed upgraded to Package 2",
  "Zaid Ali T earned RS 195 from Watching Video",
  "Sham Idrees: Withdrawal RS 1,200 successful via JazzCash",
  "Shahveer Jafry upgraded to Package 3",
  "Ducky Bhai earned RS 540 from Watching Video",
  "Moro: Withdrawal RS 1,650 successful via EasyPaisa",
  "Irfan Junejo upgraded to Package 1",
  "Amna Bibi earned RS 230 from Watching Video",
  "Khadija upgraded to Package 2",
  "Fatima: Withdrawal RS 880 successful via JazzCash",
  "Zainab earned RS 415 from Watching Video",
  "Kulsoom upgraded to Package 1",
  "Rubab: Withdrawal RS 1,300 successful via EasyPaisa",
  "Tahira earned RS 360 from Watching Video",
  "Naseem upgraded to Package 3",
  "Bakhtawar: Withdrawal RS 1,700 successful via JazzCash",
  "Deposit RS 400 successful via EasyPaisa - Instant",
  "Asifa upgraded to Package 2",
  "Bilawal earned RS 205 from Watching Video",
  "Murad Saeed: Withdrawal RS 1,250 successful via EasyPaisa",
  "Ali Amin upgraded to Package 1",
  "Pervaiz Khattak earned RS 490 from Watching Video",
  "Asad Umar: Withdrawal RS 1,100 successful via JazzCash",
  "Fawad Ch upgraded to Package 2",
  "Shireen Mazari earned RS 175 from Watching Video",
  "Sheikh Rasheed: Withdrawal RS 950 successful via EasyPaisa",
  "Khawaja Asif upgraded to Package 3",
  "Ayaz Sadiq earned RS 335 from Watching Video",
  "Rana Sanaullah: Withdrawal RS 1,400 successful via JazzCash",
  "Sherry Rehman upgraded to Package 1",
  "Yousuf Raza: Withdrawal RS 1,800 successful via EasyPaisa",
  "Raja Pervaiz upgraded to Package 2",
  "Aitzaz Ahsan earned RS 420 from Watching Video",
  "Latif Khosa: Withdrawal RS 1,550 successful via JazzCash",
  "Babar Ghauri upgraded to Package 3",
  "Haider Abbas earned RS 285 from Watching Video",
  "Mustafa Kamal: Withdrawal RS 1,100 successful via EasyPaisa",
  "Anis Kaimkhani upgraded to Package 1",
  "Farooq Sattar earned RS 395 from Watching Video",
  "Khalid Maqbool: Withdrawal RS 1,900 successful via JazzCash",
  "Afshaan upgraded to Package 2",
  "Mehwish: Withdrawal RS 1,450 successful via EasyPaisa",
  "Saba Ahmed earned RS 225 from Watching Video",
  "Naila upgraded to Package 1",
  "Uzma: Withdrawal RS 1,300 successful via JazzCash",
  "Bushra upgraded to Package 3",
  "Fiza earned RS 190 from Watching Video",
  "Samina: Withdrawal RS 1,150 successful via EasyPaisa",
  "Kiran upgraded to Package 2",
  "Sonia earned RS 465 from Watching Video",
  "Shazia: Withdrawal RS 1,100 successful via JazzCash",
  "Ambreen upgraded to Package 1",
  "Maliha earned RS 340 from Watching Video",
  "Saira: Withdrawal RS 1,750 successful via EasyPaisa",
  "Nadia upgraded to Package 3",
  "Rabia earned RS 270 from Watching Video",
  "Asma: Withdrawal RS 920 successful via JazzCash",
  "Hina upgraded to Package 2",
  "Laila earned RS 510 from Watching Video",
  "Sanam: Withdrawal RS 1,600 successful via EasyPaisa",
  "Mehak upgraded to Package 1",
  "Iqra earned RS 185 from Watching Video",
  "Zunaira: Withdrawal RS 1,200 successful via JazzCash",
  "Fareeha upgraded to Package 3",
  "Saima earned RS 435 from Watching Video",
  "Sadia: Withdrawal RS 1,550 successful via EasyPaisa",
  "Humaira upgraded to Package 2",
  "Shagufta earned RS 305 from Watching Video",
  "Nasreen: Withdrawal RS 1,900 successful via JazzCash",
  "Khalida upgraded to Package 1",
  "Rashida earned RS 245 from Watching Video",
  "Parveen: Withdrawal RS 1,400 successful via EasyPaisa",
  "Zubaida upgraded to Package 3",
  "Shamim earned RS 370 from Watching Video",
  "Kausar: Withdrawal RS 1,800 successful via JazzCash",
  "Bilqis upgraded to Package 2",
  "Kaneez earned RS 215 from Watching Video",
  "Sakina: Withdrawal RS 950 successful via EasyPaisa",
  "Farhat upgraded to Package 1",
  "Zahida earned RS 480 from Watching Video",
  "Riffat: Withdrawal RS 1,400 successful via JazzCash",
  "Nazia upgraded to Package 3",
  "Ishrat earned RS 160 from Watching Video",
  "Nuzhat: Withdrawal RS 1,100 successful via EasyPaisa",
  "Shama upgraded to Package 2",
  "Gulnaz earned RS 325 from Watching Video",
  "Shehnaz: Withdrawal RS 1,300 successful via JazzCash",
  "Mumtaz upgraded to Package 1",
  "Aisha earned RS 445 from Watching Video",
  "Fatima: Withdrawal RS 1,700 successful via EasyPaisa",
  "Khursheed upgraded to Package 3",
  "Rehana earned RS 290 from Watching Video",
  "Arifa: Withdrawal RS 1,100 successful via JazzCash",
  "Suraiya upgraded to Package 2",
  "Jamila earned RS 135 from Watching Video",
  "Saleema: Withdrawal RS 1,250 successful via EasyPaisa",
  "Naseema upgraded to Package 1",
  "Razia earned RS 395 from Watching Video",
  "Safia: Withdrawal RS 1,200 successful via JazzCash",
  "Hanifa upgraded to Package 3",
  "Anwari earned RS 265 from Watching Video",
  "Zohra: Withdrawal RS 1,500 successful via EasyPaisa",
  "Badar upgraded to Package 2",
  "Qamar earned RS 475 from Watching Video",
  "Khurshid: Withdrawal RS 1,800 successful via JazzCash",
  "Shaukat upgraded to Package 1",
  "Iqbal earned RS 180 from Watching Video",
  "Anwar: Withdrawal RS 1,100 successful via EasyPaisa",
  "Akbar upgraded to Package 3",
  "Asghar earned RS 410 from Watching Video",
  "Sajid: Withdrawal RS 1,600 successful via JazzCash",
  "Majid upgraded to Package 2",
  "Zahid earned RS 235 from Watching Video",
  "Abid: Withdrawal RS 1,450 successful via EasyPaisa",
  "Khalid upgraded to Package 1",
  "Nasir earned RS 365 from Watching Video",
  "Tahir: Withdrawal RS 1,100 successful via JazzCash",
  "Zubair upgraded to Package 3",
  "Umair earned RS 190 from Watching Video",
  "Adnan: Withdrawal RS 1,200 successful via EasyPaisa",
  "Kamran upgraded to Package 2",
  "Salman earned RS 430 from Watching Video",
  "Rehan: Withdrawal RS 1,900 successful via JazzCash",
  "Faisal upgraded to Package 1",
  "Bilal earned RS 315 from Watching Video",
  "Hamza: Withdrawal RS 1,750 successful via EasyPaisa",
  "Usman upgraded to Package 3",
  "Rizwan earned RS 280 from Watching Video",
  "Zeeshan: Withdrawal RS 950 successful via JazzCash",
  "Ahsan upgraded to Package 2",
  "Mohsin earned RS 520 from Watching Video",
  "Waqas: Withdrawal RS 1,600 successful via EasyPaisa",
  "Arsalan upgraded to Package 1",
  "Jawad earned RS 205 from Watching Video",
  "Saad: Withdrawal RS 1,300 successful via JazzCash",
  "Fahad upgraded to Package 3",
  "Asad earned RS 455 from Watching Video",
  "Talha: Withdrawal RS 1,400 successful via EasyPaisa",
  "Haris upgraded to Package 2",
  "Omer earned RS 340 from Watching Video",
  "Zain: Withdrawal RS 1,150 successful via JazzCash",
  "Taimoor upgraded to Package 1",
  "Daniyal earned RS 485 from Watching Video",
  "Shahid: Withdrawal RS 1,300 successful via EasyPaisa",
  "Shoaib upgraded to Package 3",
  "Farhan earned RS 220 from Watching Video",
  "Waseem: Withdrawal RS 1,900 successful via JazzCash",
  "Adeel upgraded to Package 2",
  "Kashif earned RS 375 from Watching Video",
  "Nadeem: Withdrawal RS 1,400 successful via EasyPaisa",
  "Ameer upgraded to Package 1",
  "Raza earned RS 165 from Watching Video",
  "Sami: Withdrawal RS 1,250 successful via JazzCash",
  "Imad upgraded to Package 3",
  "Faheem earned RS 495 from Watching Video",
  "Babar: Withdrawal RS 1,750 successful via EasyPaisa",
  "Azhar upgraded to Package 2",
  "Misbah earned RS 305 from Watching Video",
  "Sarfaraz: Withdrawal RS 1,500 successful via JazzCash",
  "Shaheen upgraded to Package 1",
  "Shadab earned RS 440 from Watching Video",
  "Hassan: Withdrawal RS 1,100 successful via EasyPaisa",
  "Haris upgraded to Package 3",
  "Naseem earned RS 265 from Watching Video",
  "Iftikhar: Withdrawal RS 1,100 successful via JazzCash",
  "Saim upgraded to Package 2",
  "Zaman earned RS 415 from Watching Video",
  "Abbas: Withdrawal RS 1,200 successful via EasyPaisa",
  "Haider upgraded to Package 1",
  "Asif earned RS 185 from Watching Video",
  "Tayyab: Withdrawal RS 920 successful via JazzCash",
  "Mirza upgraded to Package 3",
  "Abrar earned RS 390 from Watching Video",
  "Agha: Withdrawal RS 1,400 successful via EasyPaisa",
  "Waqar upgraded to Package 2",
  "Saqlain earned RS 530 from Watching Video",
  "Deposit RS 2,000 successful via JazzCash - Instant Credit",
  "Zeeshan: Withdrawal RS 450 successful via EasyPaisa",
  "Muneeb upgraded to Package 1",
  "Ali Khan earned RS 120 from Watching Video",
  "Deposit RS 1,500 successful via Bank Account"
];
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Pehle purani value fade out hogi

      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % activities.length);
        setFade(true); // Nayi value fade in hogi
      }, 500); // 0.5 second ka gap transition ke liye

    }, 4000); // Har 4 second baad change hoga

    return () => clearInterval(interval);
  }, [activities.length]);
  ////////////////////////////Use Navigater
  const navigate = useNavigate();

  const auth = getAuth(app);
  const signUpUser = () => {
    if (userName === undefined) {
      const notify = () => toast.error("Kindly Enter UserName");
      notify();
      return false;
    }
    if (refsCode === undefined) {
      const notify = () => toast.error("Kindly Enter Referal Code");
      notify();
      return false;
    }
    ///////////////////Sign Up User Func
    createUserWithEmailAndPassword(
      auth,
      email,
      password,
      userName,
      bal,
      refsCode
    )
      .then((userCredential) => {
        // Signed up

        const user = userCredential.user;
        console.log(user.uid);
        setLoading(true);
        const userId = user.uid;
        cloud(email, password, userName, userId);
        writeUserData(userId, userName, email, password, bal, refsCode);
        const db = getDatabase(app);
        const aaas = ref(db, `Users / ${currentDate}/${userId} `);

        update(aaas, {
          UserLastSeen: ` Date : `,
          Email: `email`,
        });
        setTimeout(() => {
          navigate("/signin");
        }, 3000);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
        signUpError(errorMessage);
      });
  };

  //////////////////// Storing Data user in Cloud Database
  const db = getFirestore(app);
  const cloud = async (email, password, userName, userId) => {
    try {
      const results = await addDoc(collection(db, userName), {
        username: userName,
        email: email,
        password: password,
        userid: userId,
      });

      console.log("Document written with ID: ");
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  };

  //////////Store data in RealTime Database

  function writeUserData(userId, userName, email, password, bal, refsCode) {
    const db = getDatabase(app);
    console.log(`hayee`);
    set(ref(db, userId), {
      username: userName,
      email: email,
      password: password,
      userid: userId,
      Bal: bal,
      Withdrewl: {
        withdrewlBtnShow: true,
        withdrewl: false,
        withdrewlAmount: 0,
      },
      AddUser: {
        addusers: "0",
        ReferalAmount: "0",
      },
      accountInfo: {
        Number: "/////////",
        Name: "/////////",
        Account: "/////////",
      },
      Packages: {
        package1: true,
        package2: false,
        package3: false,
        package4: false,
      },
      Msg: {
        pack1: true,
        pack2: false,
        pack3: false,
        pack4: false,
      },
      URL: {
        pack1: "https://youtu.be/ckDDp9xaGW8?si=IuNlmKS9N-z7S8qv",
        pack2: "https://youtu.be/ckDDp9xaGW8?si=IuNlmKS9N-z7S8qv",
        pack3: "https://youtu.be/ckDDp9xaGW8?si=IuNlmKS9N-z7S8qv",
        pack4: "https://youtu.be/ckDDp9xaGW8?si=IuNlmKS9N-z7S8qv",
      },
      Btn: {
        Pack1Btn: 0,
        Pack2Btn: 0,
        Pack3Btn: 0,
        Pack4Btn: 0,
      },
      referal: refsCode,
      MsgForDeveloper:
        "1 videos free... watch now",
      z: {
        Videos: {
          pack1: "",
          pack2: "",
          pack3: "",
          pack4: "",
        },
        profits: {
          pack1: "",
          pack2: "",
          pack3: "",
          pack4: "",
        },
      },
    });
  }

  /////////////////////////Sign Up Error
  const signUpError = (errorMessage) => {
    if (
      errorMessage ===
      "Firebase: Password should be at least 6 characters (auth/weak-password)."
    ) {
      const notify = () => toast.error("Password Must be 6 Charactors!");
      notify();
    } else if (
      errorMessage === "Firebase: Error (auth/email-already-in-use)."
    ) {
      const notify = () =>
        toast.error("This Email address is already registered");
      notify();
    } else if (
      errorMessage === "Firebase: Error (auth/network-request-failed)."
    ) {
      const notify = () => toast.error("Oops! No internet connection.");
      notify();
    }
  };

  ///////////////////////Password Show Hide Func
  const chkPass = () => {
    if (checkPass == false) {
      setCheckPass(true);
    } else {
      setCheckPass(false);
    }
  };

  const submitHandler = (event) => {
    event.preventDefault();
  };

  return (
    <div className="main-app-wrapper">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        className="Toaster"
      />

      <Container className="d-flex justify-content-center">
        <Form onSubmit={submitHandler} className="custom-form-card shadow-lg">
          <h1 className="text-center fw-bolder signup-title">Sign Up</h1>

          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="mt-2 custom-label">Username</Form.Label>
            <Form.Control
              type="username"
              placeholder="Username"
              required
              onChange={(e) => setUserName(e.target.value)}
              className={`${empty ? "custom-input" : "border-danger custom-input"}`}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="custom-label">Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              required
              onChange={(e) => SetEmail(e.target.value)}
              className={`${empty ? "custom-input" : "border-danger custom-input"}`}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label className="custom-label">Password</Form.Label>
            <Form.Control
              type={checkPass ? "text" : "password"}
              placeholder="Password"
              required
              onChange={(e) => {
                SetPassword(e.target.value);
              }}
              className={`custom-input ${chk ? "text-red" : ""} ${empty ? "" : "border-danger"
                } `}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicCheckbox">
            <Form.Check
              type="checkbox"
              label="Show Password"
              className="m-2 custom-checkbox"
              onClick={() => {
                chkPass();
              }}
            />
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="custom-label">Referal Code</Form.Label>
              <Form.Control
                type="text"
                className="custom-input"
                placeholder="Optional"
                onChange={(e) => setrefCode(e.target.value)}
              />
            </Form.Group>
          </Form.Group>

          {!loading ? (
            <Button
              className="m-1 register-btn w-100"
              variant="outline-primary"
              type="submit"
              onClick={() => {
                signUpUser();
              }}
            >
              Register Now
            </Button>
          ) : (
            <div className="text-center"><Spinner animation="border" variant="primary" /></div>
          )}
        </Form>
      </Container>

      <Container className="text-center">
        <div className="gap-2">
          <Link to="/signin" className="list-group-item m-1">
            <Button variant="outline-success" size="md" className="already-btn">
              Already have an Account?
            </Button>
          </Link>
        </div>
      </Container>

      <Container>
        <div className="mt-5 info-section">
          <Accordion defaultActiveKey={["0"]} alwaysOpen className="custom-accordion">
            <Accordion.Item eventKey="1" className="accordion-item-custom">
              <Accordion.Header>
                <h4 className="earning-header">💰 Start Earning by Watching Videos</h4>
              </Accordion.Header>
              <Accordion.Body className="accordion-body-custom">
                Sign up today and unlock the opportunity to earn money just by
                watching videos! Our platform offers a variety of engaging
                content. The more you watch, the more you earn.
                <hr />
                <p className="note-text"><strong>Note:</strong> 200+ balance par 24 hours baad 12% tax hoga.</p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="0" className="accordion-item-custom">
              <Accordion.Header>
                <h4 className="earning-header">📈 How much can you Earn?</h4>
              </Accordion.Header>
              <Accordion.Body className="accordion-body-custom">
                <div>If you buy our All Packages...</div>
                <div className="earn-amount">You can Earn 1500rs per Day!</div>
                <div className="mt-2">
                  <h4 className="text-success secure-tag">
                    🛡️ 100% Secure Pakistan Platform
                  </h4>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </Container>
      <div className="ticker-wrapper">
        <div className={`ticker-card ${fade ? 'fade-in' : 'fade-out'}`}>
          <div className="pulse-dot"></div>
          <span className="ticker-text">{activities[currentIndex]}</span>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
